import { render, staticRenderFns } from "./langsch.vue?vue&type=template&id=2639daaf&scoped=true&"
import script from "./langsch.vue?vue&type=script&lang=js&"
export * from "./langsch.vue?vue&type=script&lang=js&"
import style0 from "./langsch.vue?vue&type=style&index=0&id=2639daaf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2639daaf",
  null
  
)

export default component.exports